export const FONT_SIZES = Array.from({ length: 67 }).map((_item: any, idx: number) => ({
  value: idx + 6,
  label: `${idx + 6}px`
}));
